var map = {
	"./M_Brilliant.mp3": "e397",
	"./M_Excellent.mp3": "2b9f",
	"./M_Fantastic.mp3": "7ef5",
	"./M_Great.mp3": "e0c4",
	"./M_Perfect.mp3": "7f75",
	"./M_Think again.mp3": "0476",
	"./M_Try again.mp3": "740f",
	"./M_Very good.mp3": "f6ae",
	"./M_Well done.mp3": "2707",
	"./M_Work harder.mp3": "e79d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "20c4";